exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/~/core-js/library/modules/_wks-ext.js
// module id = 213
// module chunks = 0